import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import Header from '../component/Header';
import ImageCategorySelector from '../component/ImageCategorySelector';
import ImageViewer from '../component/ImageViewer';
import LoadingSpinner from '../component/LoadingSpinner';
import { useSelector } from 'react-redux';
import store from '../redux/store';
import { setToken } from '../redux/slices/userSlice';
import { loginRequest } from '../authConfig';
import { useNavigate } from "react-router-dom";

function Menu() {
    const { instance, accounts } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const selectedCategory = useSelector(state => state.app.selectedCategory) ?? "module"

    const [isLoading, setIsLoading] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = async () => {
            if (!accounts || accounts.length === 0) {
                navigate("/");
                return;
            }

            const request = {
                ...loginRequest,
                account: accounts[0]
              };

            try {
                await instance.acquireTokenSilent(request).then(response => {
                    const accessToken = response.accessToken;
                    store.dispatch(
                        setToken({ token: accessToken })
                    );
                }).catch(error => {
                    navigate("/");
                    console.log("[ERROR] acquireTokenSilent, ", error);
                });
            } catch (e) {
                navigate("/");
            }
        };

        checkAuth();
    }, [instance, activeAccount]);

    const handleRefresh = async () => {
        // Refresh를 누르면 fetchMonotoring이 실행되어야 하는데 현재 모니터링 데이터는 쓰는 곳 없음
        setIsLoading(true)
        setIsRefreshing(true);
        setTimeout(() => {
            setIsRefreshing(false);
            setIsLoading(false)
        }, 3000);
    };

    if (isLoading) {
        return <LoadingSpinner message="Loading production images..." />;
    }

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Navigation Header */}
            <Header
                isRefreshing={isRefreshing}
                onRefresh={handleRefresh}
                title="MSV Monitoring"
            />

            {/* Main Content */}
            <main className="px-4 py-6 space-y-6">

                {/* Image Category Selector */}
                <ImageCategorySelector />

                {/* Image Viewer - Full Width */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <div className="flex items-center justify-between mb-6">
                        <h3 className="text-lg font-semibold text-gray-900">
                            {/* {selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1)} - Timeline */}
                        </h3>
                        <div className="flex items-center space-x-2 text-sm text-gray-500">
                            <div className={`w-2 h-2 ${isImageLoading ? 'bg-blue-500' : error == null ? 'bg-green-500' : 'bg-red-600'} rounded-full animate-pulse`}></div>
                            <span>{isImageLoading ? 'Fetching' : error == null ? 'Updated' : 'Error'}</span>
                        </div>
                    </div>
                    <ImageViewer category={selectedCategory}
                        onError={
                            (err) => setError(err)
                        }
                        onLoading={
                            (isLoading) => setIsImageLoading(isLoading)
                        }
                    />
                </div>
            </main>
        </div>
    )
}

export default Menu;
